<template>
	<div class="unloading_box animate__animated animate__fadeIn">
		<div class="unloading">
			<div class="content_list">
				<div class="item_title">
					<div class="bar">设备编号：{{ currentUnloading.number ? currentUnloading.number : '' }}</div>
					<div class="bar">运行状态：{{ currentUnloading.eqptStatus ? fnUnloadingStatusToText(currentUnloading.eqptStatus).msg : '' }}</div>
					<div class="operation">
                        <!-- <div class="search-btn orange" @click="showMark=true"><span>标定</span></div> -->
						<div class="search-btn orange" @click="fnRefresh"><span>刷新</span></div>
					</div>
				</div>
				<div class="item_box">
					<div class="box" v-show="statusIndex == 0"><Data :currentUnloading="currentUnloading" /></div>
					<div class="box" v-show="statusIndex == 2"><alarm :currentUnloading="currentUnloading" /></div>
					<div class="box" v-show="statusIndex == 3"><realTimeRecord :currentUnloading="currentUnloading" /></div>
				</div>
			</div>
			<div class="data_list">
				<div class="title">卸料平台({{ unloadingData.length }}台)</div>
				<div class="list_title">
					<div class="title_item">设备编号</div>
					<div class="title_item">在线状态</div>
				</div>
				<div class="list_box">
					<div v-if="unloadingData">
						<div
							class="box_line"
							v-for="(item, index) in unloadingData"
							:key="item.id"
							@click="fnUnloadingToggle(item, index)"
							:class="currentUnloadingIndex == index ? 'active' : ''"
						>
							<div class="line_item">{{ item.number }}</div>
							<div class="line_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import Data from './components/Data';
import Alarm from './components/Alarm';
import realTimeRecord from './components/realTimeRecord';
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo, getEqptInfo, removeEqptInfo } from '@/utils/auth';
export default {
	components: {
		Data,
		Alarm,
		realTimeRecord
	},
	data() {
		return {
            activeName: 'first',
            showMark: false,
			timer: null,
			projectInfo: null, // 传递过来的项目信息
			projectName: '',
			statusIndex: 0,
			currentUnloadingIndex: 0,
			unloadingData: [], // 卸料平台列表
			currentUnloading: {
				number: '',
				eqptStatus: '',
				nowTime:''
			} ,// 当前设备信息
            isIndex: false,
            indexMsg: null,
		};
	},
	created() {
        let _msg = getEqptInfo()
        if(_msg&&_msg.pointType == '卸料平台'){
            this.isIndex = true
            this.indexMsg = _msg.pointNumber
        }
		this.projectID = getUserInfo().id;
		this.fnInit();
		this.timer = setInterval(() => {
			this.fnGetUnloadingList();
		}, 100000);
	},
	beforeDestroy() {
        removeEqptInfo()
		clearInterval(this.timer);
	},
	methods: {
        handleClick(tab, event) { },
		// 查看卸料平台运行记录
		fnOpenUnloadingRealTimeRecord() {
			this.statusIndex = 3;
		},
		// 查看卸料平台预报警次数
		fnOpenUnloadingAlarm() {
			this.statusIndex = 2;
		},
		// 查看装载记录
		fnOpenHoistingRecord() {
			this.statusIndex = 1;
		},
		// 查看实时数据
		fnOpenHome() {
			this.statusIndex = 0;
		},
		// 记录切换
		fnStatusToggle(_el) {
			let _index = _el.target.dataset.index;
			if (_index != this.statusIndex) {
				this.statusIndex = _index;
			}
		},
		// 初始化
		fnInit() {
			this.fnGetUnloadingList();
		},
		// 获取卸料平台列表
		fnGetUnloadingList() {
			request({
				notLoading: true,
				url: 'unloading/get',
				method: 'GET',
				params: {
					project_id: this.projectID
				}
			})
				.then(res => {
					if (res.data.query.length > 0) {
						this.unloadingData = res.data.query;
                        if(this.isIndex){
                            for(let i in this.unloadingData){
                                if(this.unloadingData[i].number == this.indexMsg){
                                    this.currentUnloadingIndex = i
                                    this.currentUnloading.number = this.unloadingData[i].number;
                                    this.currentUnloading.eqptStatus = this.unloadingData[i].eqptStatus;
                                    this.currentUnloading.nowTime = ''+ new Date().getTime()
                                }
                            }
                        }else{
                            if (!this.currentUnloading.number) {
                                this.currentUnloading.number = res.data.query[0].number;
                                this.currentUnloading.eqptStatus = res.data.query[0].eqptStatus;
                                this.currentUnloading.nowTime = ''+ new Date().getTime()
                            }
                        }
					} else {
						this.currentUnloading.number = '';
						this.currentUnloading.eqptStatus = '';
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 卸料平台运行状态
		fnUnloadingStatusToText(_status) {
			if (_status) {
				return APP.fnCraneStatusToText(_status, 'unloading');
			}
		},
		// 获取选中卸料平台信息
		fnUnloadingToggle(_item, _index) {
			this.currentUnloadingIndex = _index;
			request({
				url: 'unloading/get',
				method: 'GET',
				params: {
					project_id: this.projectID,
					number: _item.number
				}
			})
				.then(res => {
					if (res.data.query.length > 0) {
						this.currentUnloading.number = res.data.query[0].number;
						this.currentUnloading.eqptStatus = res.data.query[0].eqptStatus;
						this.currentUnloading.nowTime = ''+ new Date().getTime()
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 卸料平台在线状态
		fnOnlineStatusText(_heartbeatTime) {
			return APP.fnOnlineStatusText(_heartbeatTime);
		},
		// 刷新
		fnRefresh() {
			if (this.unloadingData.length > 0) {
				this.fnUnloadingToggle(this.unloadingData[this.currentUnloadingIndex], this.currentUnloadingIndex);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.unloading_box{
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.unloading{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.content_list{
	position: absolute;
	top: 0;
	left: 0;
	width: 1600px;
	height: 858px;
	.item_title{
		width: 1580px;
		height: 60px;
		margin: 10px;
		position: relative;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start,center);
	}
	.bar{
		font-size: 20px;
		margin: 0 20px;
	}
	.operation{
		position: absolute;
		right: 10px;
		@include flex-box();
		// .add_btn {
		// 	width: 85px;
		// 	height: 32px;
		// 	line-height: 32px;
		// 	margin: 0 2px;
		// 	font-size: 14px;
		// 	color: #ffffff;
		// 	border: none;
		// 	cursor: pointer;
		// 	background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
		// 	background-size: 100% 100%;
		// 	@include flex-box(center, center);
		// 	span {
		// 		margin-top: -2px;
		// 	}
		// }
	}
	.item_box{
		width: 1600px;
		height: 778px;
	}
}
.data_list{
	position: absolute;
	top: 0;
	left: 1620px;
	width: 300px;
	height: 848px;
	margin-top: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.title {
		width: 300px;
		height: 60px;
		font-size: 24px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(center,center);
	}
	.list_title{
		width: 300px;
		height: 48px;
		background: url(../../../assets/img/enter_left_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item{
			width: 96px;
			margin: 0 2px;
			text-align: center;
            &:nth-child(1){
            	width: 196px;
            }
		}
	}
	.list_box{
		width: 300px;
		height: 740px;
		.box_line{
			width: 300px;
			height: 48px;
			cursor: pointer;
			border-bottom: 1px dashed #1d4495;
			@include flex-box(center,center);
			&:hover{
				background-color: rgba(49, 88, 128, 0.4);
			}
			&.active{
				color: #0080FF;
			}
			.line_item{
				width: 96px;
				margin: 0 2px;
				text-align: center;
                &:nth-child(1){
                	width: 196px;
                }
			}
		}
	}
}

>>> .el-pager .more:before {
	content: '\E794';
}
>>> .el-switch.is-checked .el-switch__core:after {
	content: '';
}
.dialog_mark{
    >>>.el-dialog {
    	width: 720px;
        height: 470px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58,116,221,1);
    }
    >>>.el-dialog__body{
      padding: 10px;
      height: 360px;
    }
    >>>.el-form-item__label{
    	color: #4DB4F4;
    }
    >>>.el-dialog__title{
    	color: #4DB4F4;
    }
    >>>.el-dialog__close{
    	color: #4DB4F4;
    }
    .btn_line{
        @include flex-box(center,center);
    }
    .mark_content{
      width: 700px;
      height: 340px;
      color: #4DB4F4;
      >>>.el-tabs__item{
          color: #FFFFFF;
      }
      >>>.el-tabs__item.is-active{
          color: #409eff;
      }
      .first_box,.second_box,.third_box{
        width: 700px;
        height: 280px;
        @include flex-box(flex-start,center,column);
        .box_line{
          width: 700px;
          height: 50px;
          line-height: 50px;
          @include flex-box(space-around,center);
          .line_item{
            width: 310px;
            &.btn{
              width: 80px;
            }
            .title{
              display: inline-block;
              width: 100px;
            }
            >>>.el-input{
                width: 170px;
            }
            >>>.el-input__inner{
                width: 170px;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border: 0;
                outline:none;
                background-color: rgba(49, 88, 128, 0.4);
                &::-webkit-input-placeholder{
                	color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder{   /* Mozilla Firefox 19+ */
                	color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                	color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder{  /* Internet Explorer 10-11 */
                	color: rgba(77, 180, 244, 0.7);
                }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Unloading/unloadingDefault/index.vue